export var LabelAlign;
(function (LabelAlign) {
    LabelAlign["left"] = "left";
    LabelAlign["center"] = "center";
    LabelAlign["right"] = "right";
})(LabelAlign || (LabelAlign = {}));
export var LabelLayout;
(function (LabelLayout) {
    LabelLayout["horizontal"] = "horizontal";
    LabelLayout["vertical"] = "vertical";
    LabelLayout["placeholder"] = "placeholder";
    LabelLayout["float"] = "float";
    LabelLayout["none"] = "none";
})(LabelLayout || (LabelLayout = {}));
export var FormLayout;
(function (FormLayout) {
    FormLayout["table"] = "table";
    FormLayout["none"] = "none";
})(FormLayout || (FormLayout = {}));
export var ResponsiveKeys;
(function (ResponsiveKeys) {
    ResponsiveKeys["xs"] = "xs";
    ResponsiveKeys["sm"] = "sm";
    ResponsiveKeys["md"] = "md";
    ResponsiveKeys["lg"] = "lg";
    ResponsiveKeys["xl"] = "xl";
    ResponsiveKeys["xxl"] = "xxl";
})(ResponsiveKeys || (ResponsiveKeys = {}));
export var ShowValidation;
(function (ShowValidation) {
    ShowValidation["tooltip"] = "tooltip";
    ShowValidation["newLine"] = "newLine";
})(ShowValidation || (ShowValidation = {}));
export var SpacingType;
(function (SpacingType) {
    SpacingType["around"] = "around";
    SpacingType["between"] = "between";
    SpacingType["evenly"] = "evenly";
})(SpacingType || (SpacingType = {}));
export var RequiredMarkAlign;
(function (RequiredMarkAlign) {
    RequiredMarkAlign["left"] = "left";
    RequiredMarkAlign["right"] = "right";
})(RequiredMarkAlign || (RequiredMarkAlign = {}));
